// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import AdminRoutes from './routes/AdminRoutes';
import SignInModal from './components/SignInModal';
import AppContent from './AppContent';

const AppRouter = () => {
  const [userRole, setUserRole] = useState(null); // e.g., 'ADMIN', 'STUDENT', null for unauthenticated
  const [modalVisible, setModalVisible] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Show modal for /admin/* (protected routes) or /signin (manual sign-in)
    if (!userRole && (location.pathname.startsWith('/admin') || location.pathname === '/signin')) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [userRole, location.pathname]);

  const handleLoginSuccess = (role) => {
    setUserRole(role);
    setModalVisible(false);
    // Redirect based on role after login
    const redirectPaths = {
      ADMIN: '/admin/dashboard',
      STUDENT: '/student/dashboard',
      MENTOR: '/mentor/dashboard',
      VENDOR: '/vendor/dashboard',
    };
    navigate(redirectPaths[role] || '/');
  };

  const handleLogout = () => {
    setUserRole(null);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    if (location.pathname.startsWith('/admin') || location.pathname === '/signin') {
      navigate('/'); // Redirect to home if closing from admin or signin route
    }
  };

  return (
    <>
      <Routes>
        <Route
          path="/admin/*"
          element={
            userRole ? (
              <AdminRoutes userRole={userRole} onLogout={handleLogout} />
            ) : (
              <Navigate to="/signin" replace /> // Changed from '/' to '/signin'
            )
          }
        />
        <Route
          path="/"
          element={<AppContent userRole={userRole} onLogout={handleLogout} />}
        />
        <Route
          path="/signin"
          element={<AppContent userRole={userRole} onLogout={handleLogout} />}
        />
        <Route
          path="/*"
          element={<AppContent userRole={userRole} onLogout={handleLogout} />}
        />
      </Routes>

      {modalVisible && (
        <SignInModal
          visible={modalVisible}
          onClose={handleCloseModal}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppRouter />
    </Router>
  );
};

export default App;